import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class HeadingText {
    constructor(container) {
        this.container = container;
        this.heading = this.container.querySelector('.heading-text__heading');
        this.body = this.container.querySelector('.heading-text__body');

        this.init();
    }

    init = () => {
        if (this.heading) {
            this.headingSplit_lines = new SplitText(this.heading, { type: 'lines,words', linesClass: 'lineParent' });
            this.headingSplit = new SplitText(this.heading.querySelectorAll('.lineParent'), { type: 'lines,words' });

            gsap.fromTo(
                this.headingSplit.lines,
                { yPercent: 100 },
                {
                    yPercent: 0,
                    duration: 0.9,
                    ease: 'power3.out',
                    stagger: { each: 0.08, from: 'start' },
                    scrollTrigger: {
                        trigger: this.heading,
                        start: 'top 85%',
                    },
                    onComplete: () => {
                        this.headingSplit_lines.revert();
                        this.headingSplit.revert();

                    },
                }
            );
        }

        if (this.body) {
            this.bodySplit_lines = new SplitText(this.body, { type: 'lines', linesClass: 'lineParent' });
            this.bodySplit = new SplitText(this.body.querySelectorAll('.lineParent'), { type: 'lines' });

            gsap.fromTo(
                this.bodySplit.lines,
                { yPercent: 100 },
                {
                    yPercent: 0,
                    duration: 0.6,
                    ease: 'power2.out',
                    stagger: { each: 0.2, from: 'start' },
                    scrollTrigger: {
                        trigger: this.body,
                        start: 'top 85%',
                    },
                    onComplete: () => {
                        this.bodySplit_lines.revert();
                        this.bodySplit.revert()
                    },
                }
            );
        }
    };


}
